import React from 'react';
import { AboutUs, Chef, Footer, Preview } from './container';
import './App.css';

const App = () => (
  <div className>
    <AboutUs />
    <Chef />
    <Preview />
    <Footer />
  </div>
);

export default App;
